import $ from 'jquery';
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css';
import './similarModule.scss';

export default function () {
    const $swipeOverlay = $('.product-model-similar-container .swipe-overlay');
    const $wrapper = $('.product-model-similar-container .swiper-wrapper');
    const $slides = $('.product-model-similar-container .swiper-slide');
    const $arrows = $('.product-model-similar-container .swiper-button-prev, .product-model-similar-container .swiper-button-next');
    let isOverlayHiddenByTouch = false;
    const gallerySimilar = new Swiper('.swiper-container-similar', {
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 30,
        loop: false,
        freeMode: false,
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        pagination: '.pagination',
        paginationType: 'custom',
        paginationCustomRender: function (swiper) {
            return '<span class="">' + (swiper.activeIndex + 1) + ' - ' + (swiper.activeIndex + swiper.currentSlidesPerView()) + '</span>' +
                '<span class="crux-body-copy crux-body-copy--small--bold"> of ' + swiper.slides.length + '</span> ' +
                '<span>Models</span>';
        },
        breakpoints: {
            768: {
                freeMode: true,
                slidesPerView: 'auto',
                slidesPerGroup: 1,
                spaceBetween: 20,
            },
            991: {
                freeMode: true,
                slidesPerView: 'auto',
                slidesPerGroup: 1,
                spaceBetween: 50
            }
        },
        onInit: function(swiper) {
            updateGallery(swiper);
            updateSwiperElementsVisibility();
        },
        onAfterResize: function(swiper) {
            updateGallery(swiper);
            updateSwiperElementsVisibility();
        },
        onTouchStart: function() {
            $swipeOverlay.hide();
            isOverlayHiddenByTouch = true;
        }
    });

    function updateGallery(swiper) {
        let viewPort = getViewportWidth();
        let $slides = $(swiper.slides);

        if (viewPort < 768) {
            $slides.css('width', '200px');
        } else if(viewPort < 992) {
            $slides.css('width', '300px');
        }

        swiper.update();
    }

    function getViewportWidth() {
        return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    }

    function updateSwiperElementsVisibility() {
        const wrapperWidth = $wrapper.outerWidth(true);
        const slidesWidth = $slides.eq(0).outerWidth(true) * $slides.length - parseInt($slides.css('margin-right'));
        $arrows.toggleClass('hidden', wrapperWidth >= slidesWidth);

        if (isOverlayHiddenByTouch) return;
        $swipeOverlay.toggleClass('hidden', wrapperWidth >= slidesWidth);
    }
}



// WEBPACK FOOTER //
// ./resources/modules/products/v2_0/components/SimilarModule/index.js